<template>
  <a
    :href="whatsappLink"
    target="_blank"
    rel="noopener"
    class="whatsapp-button d-flex align-items-center justify-content-center"
    :aria-label="t('components.whatsapp-button.aria-label')"
  >
    <i class="bi bi-whatsapp"></i>
  </a>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const whatsappLink =
  "https://wa.me/38975201677?text=" +
  encodeURIComponent(t("components.whatsapp-button.prefilled-message"));
</script>

<style scoped>
.whatsapp-button {
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: #25d366;
  color: #ffffff;
  font-size: 28px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  z-index: 1030;
  transition: transform 0.2s ease-in-out;
}

.whatsapp-button:hover {
  transform: scale(1.08);
  color: #ffffff;
}
</style>
